import { createApp } from 'vue'
import App from './App.vue'
import Router from './router/index.js'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './assets/less/index.less'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from '@/store/index'
import VueParticles from 'vue-particles'
import request from '@/request/request'
import { ElMessageBox } from 'element-plus'
import { loading, schoolChage, getBase64, dateFormat } from '@/utils/util'
import moent from 'moment'
import bus from '@/utils/bus'
import signlar from '@/utils/signlar'
import Editor from "@/components/quillEditor"
import template from "@/utils/makeTemplate"
import { installDirectives } from '@/directives'
import { printscreen } from '@/utils/abnormalScreenshot'
import openWindow from '@/utils/routeHref'

window.addEventListener('unhandledrejection', function (e) {
    if (e.reason?.message?.includes('Loading chunk')) {
        window.location.reload()
    }
})

const app = createApp(App);
app.use(Router).use(store).use(ElementPlus, { locale: zhCn }).use(VueParticles);

// 注册自定义指令
installDirectives(app, {
    globalOptions: {
        delimiters: [{
            left: "$$",
            right: "$$",
            display: !0
        }, {
            left: "$",
            right: "$",
            display: !0
        }, {
            left: "\\(",
            right: "\\)",
            display: !1
        }, {
            left: "\\[",
            right: "\\]",
            display: !0
        }],
        output: "html",
        throwOnError: !1,
        errorColor: "transparent"
    }
});

app.mount('#app');
app.config.globalProperties.$request = request;
app.config.globalProperties.$moent = moent
app.config.globalProperties.$bus = bus
app.config.globalProperties.$elLoading = { loading };
app.config.globalProperties.$util = { schoolChage, getBase64, dateFormat };
app.config.globalProperties.$elMessageBox = ElMessageBox
app.config.globalProperties.$icons = []
app.config.globalProperties.$signlar = signlar
app.config.globalProperties.$template = template
app.config.globalProperties.$printscreen = printscreen
app.config.globalProperties.$openWindow = openWindow
//注册全局组件
app.component('Editor', Editor);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
    app.config.globalProperties.$icons.push(key)
}

